export var PhotoCategory;
(function (PhotoCategory) {
    PhotoCategory["Damage"] = "damage";
    PhotoCategory["General"] = "general";
    PhotoCategory["Blackboard"] = "blackboard";
    PhotoCategory["Overview"] = "overview";
    PhotoCategory["Reference"] = "reference";
    PhotoCategory["Equipment"] = "equipment";
})(PhotoCategory || (PhotoCategory = {}));
export var PhotoStatus;
(function (PhotoStatus) {
    PhotoStatus["Uploaded"] = "uploaded";
    PhotoStatus["Processed"] = "processed";
})(PhotoStatus || (PhotoStatus = {}));
export var PhotoType;
(function (PhotoType) {
    PhotoType["Main"] = "main";
    PhotoType["Closeup"] = "closeup";
    PhotoType["Measurement"] = "measurement";
    PhotoType["DifferentAngle"] = "different_angle";
    PhotoType["AfterRemoval"] = "after_removal";
    PhotoType["AfterTreatment"] = "after_treatment";
    PhotoType["ThinningArea"] = "thinning_area";
    PhotoType["HealthyArea"] = "healthy_area";
})(PhotoType || (PhotoType = {}));
export const FileInputKeys = ['filename', 'content_type'];
export const DamagePhotoCreateRequestBodyKeys = [
    'photo_id',
    'filename',
    'original_filename',
    'content_type',
    'photo_type',
    'photo_category',
    'is_representative',
    'damage_order',
    'caption',
    'shooting_date',
    'shooting_location',
];
export const DamagePhotoUpdateRequestBodyKeys = [
    'photo_type',
    'is_representative',
    'damage_order',
    'caption',
    'shooting_date',
    'shooting_location',
];
